import { HeadingCoreProps } from "./types"
import React from "react"
import { useTheme } from '~/ui/styled'
import styled from '~/ui/styled'

const Text = styled.Text<{ fontSize: string; color: string }>`
  font-size: ${({ theme, fontSize }) => theme.fontSizes[fontSize]};
  font-weight: bold;
  color: ${({ color }) => color};
`

export const HeadingCore: React.FC<HeadingCoreProps> = ({
  text,
  fontSize,
  color,
  ...originalTextProps
}) => {
  const theme = useTheme()
  const realColor = color || theme.colors.text
  return (
    <Text fontSize={fontSize} color={realColor} {...originalTextProps}>
      {text}
    </Text>
  )
}
